import React, { useState } from 'react';
import { Search, Filter, ChevronDown, ChevronUp } from 'lucide-react';

const PERIOD_CHIPS = [
  { id: 'today', label: "Aujourd'hui" },
  { id: '7d', label: '7 jours' },
  { id: '30d', label: '30 jours' },
];

export default function ActiviteFiltersBar({
  filters,
  isAdmin,
  onSearchChange,
  onPeriodChange,
  onMagasinChange,
  onVendeurChange,
  onDateRangeChange,
}) {
  const [filtersOpen, setFiltersOpen] = useState(false);
  const activePeriod = filters.period || '';

  return (
    <div
      className="sticky top-0 z-30 -mx-1 px-1 pb-4 space-y-3"
      data-testid="activite-filters-bar"
    >
      <div className="rounded-xl border border-white/10 bg-[#151820] p-4">
        <div className="relative">
          <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 text-gray-500" />
          <input
            type="search"
            value={filters.search}
            onChange={(e) => onSearchChange(e.target.value)}
            placeholder="Rechercher ref, client, montant…"
            className="w-full pl-10 pr-4 py-3 min-h-[44px] text-sm rounded-lg bg-black/30 border border-white/10 text-white placeholder:text-gray-500"
            data-testid="activite-filters-search"
          />
        </div>
      </div>

      <div
        className="rounded-xl border border-white/10 bg-[#151820] p-4 space-y-4"
        data-testid="activite-filters-section"
      >
        <button
          type="button"
          onClick={() => setFiltersOpen((v) => !v)}
          className="w-full flex items-center justify-between text-sm font-semibold text-gray-300"
          data-testid="activite-filters-toggle"
        >
          <span className="inline-flex items-center gap-2">
            <Filter className="w-4 h-4 text-red-400" />
            Filtres
          </span>
          {filtersOpen ? <ChevronUp className="w-4 h-4" /> : <ChevronDown className="w-4 h-4" />}
        </button>

        <div className="flex flex-wrap gap-2">
          {PERIOD_CHIPS.map((chip) => (
            <button
              key={chip.id}
              type="button"
              onClick={() => onPeriodChange(activePeriod === chip.id ? '' : chip.id)}
              className={`px-3 py-2 min-h-[40px] rounded-lg text-xs font-bold border transition-colors ${
                activePeriod === chip.id
                  ? 'border-red-500/50 bg-red-950/30 text-white'
                  : 'border-white/10 text-gray-400 hover:border-white/20'
              }`}
              data-testid={`activite-period-${chip.id}`}
            >
              {chip.label}
            </button>
          ))}
        </div>

        {filtersOpen && (
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 pt-2 border-t border-white/10">
            <div>
              <label className="block text-[10px] font-bold text-gray-500 uppercase mb-1.5">Magasin</label>
              <select
                value={filters.magasin_id}
                onChange={(e) => onMagasinChange(e.target.value)}
                className="w-full px-3 py-2.5 rounded-lg bg-black/30 border border-white/10 text-white text-sm min-h-[44px]"
                data-testid="activite-filter-magasin"
              >
                <option value="">Tous</option>
                <option value="M1">M1</option>
                <option value="M2">M2</option>
              </select>
            </div>
            {isAdmin && (
              <div>
                <label className="block text-[10px] font-bold text-gray-500 uppercase mb-1.5">Vendeur</label>
                <input
                  type="text"
                  value={filters.vendeur}
                  onChange={(e) => onVendeurChange(e.target.value)}
                  placeholder="Nom vendeur…"
                  className="w-full px-3 py-2.5 rounded-lg bg-black/30 border border-white/10 text-white text-sm min-h-[44px] placeholder:text-gray-500"
                  data-testid="activite-filter-vendeur"
                />
              </div>
            )}
            <div>
              <label className="block text-[10px] font-bold text-gray-500 uppercase mb-1.5">Du</label>
              <input
                type="date"
                value={filters.date_debut}
                onChange={(e) => onDateRangeChange({ date_debut: e.target.value, date_fin: filters.date_fin })}
                className="w-full px-3 py-2.5 rounded-lg bg-black/30 border border-white/10 text-white text-sm min-h-[44px]"
                data-testid="activite-filter-date-debut"
              />
            </div>
            <div>
              <label className="block text-[10px] font-bold text-gray-500 uppercase mb-1.5">Au</label>
              <input
                type="date"
                value={filters.date_fin}
                onChange={(e) => onDateRangeChange({ date_debut: filters.date_debut, date_fin: e.target.value })}
                className="w-full px-3 py-2.5 rounded-lg bg-black/30 border border-white/10 text-white text-sm min-h-[44px]"
                data-testid="activite-filter-date-fin"
              />
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
